// src/utils/getSessionToken.ts
import { createApp } from '@shopify/app-bridge';
import {getSessionToken} from "@shopify/app-bridge/utilities";

let app: any;

export const getAppBridge = () => {
    if (!app) {
        app = createApp({
            apiKey: process.env.REACT_APP_SHOPIFY_API_KEY!,
            host: new URLSearchParams(window.location.search).get("host")!,
            forceRedirect: true,
        });
    }
    return app;
};

export const fetchSessionToken = async () => {
    const app = getAppBridge();
    return await getSessionToken(app); // Returns a JWT
};
